import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Divider, Drawer } from '@mui/material';

import { SkipToMainContentLink } from '@/components/SkipToMainContentLink';
import { appShellInertDomProps } from '@/hooks/useInertBackground';
import { Logo } from '../../Layout/Logo';
import { useMainLayoutContext } from '../Context/useMainLayoutContext';

export const LeftDrawerV2: FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation();

  const {
    isDrawerOpen,
    drawerVariant,
    drawerSx,
    isDrawerCollapsed,
    toggleDrawer,
    navigationDrawerPaperId,
    navigationMenuButtonRef,
  } = useMainLayoutContext();

  const handleDrawerClose = () => {
    toggleDrawer(false);
    navigationMenuButtonRef.current?.focus();
  };

  return (
    <>
      <SkipToMainContentLink />

      <Drawer
        anchor="left"
        variant={drawerVariant}
        open={isDrawerOpen}
        slotProps={{
          paper: {
            id: navigationDrawerPaperId,
            role: 'navigation' as const,
            'aria-label': t('navigationMenu'),
            ...appShellInertDomProps,
            sx: drawerSx,
          },
        }}
        onClose={handleDrawerClose}
      >
        <Box
          sx={(theme) => ({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: theme.shape.borderRadius,
            ...theme.mixins.toolbar,
          })}
        >
          <Logo height={28} isCollapsed={isDrawerCollapsed} />
        </Box>

        <Divider sx={{ mb: 3, mt: '-1px' }} />

        {children}
      </Drawer>
    </>
  );
};
